const GET_MOVIE_DETAIL_LOADING = 'movie-detail/GET_MOVIE_DETAIL_LOADING';
const GET_MOVIE_DETAIL_SUCCESS = 'movie-detail/GET_MOVIE_DETAIL_SUCCESS';
const GET_MOVIE_DETAIL_ERROR = 'movie-detail/GET_MOVIE_DETAIL_ERROR';

const MOVIE_DETAIL_REMINDER = 'movie-detail/MOVIE_DETAIL_REMINDER';
const MOVIE_DETAIL_REMOVE_REMINDER = 'movie-detail/MOVIE_DETAIL_REMOVE_REMINDER';
const MOVIE_DETAIL_REMINDER_LOADING = 'mmovie-detail/MOVIE_DETAIL_REMINDER_LOADING';

export {
  GET_MOVIE_DETAIL_LOADING,
  GET_MOVIE_DETAIL_SUCCESS,
  GET_MOVIE_DETAIL_ERROR,
  MOVIE_DETAIL_REMINDER,
  MOVIE_DETAIL_REMOVE_REMINDER,
  MOVIE_DETAIL_REMINDER_LOADING,
}
